// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"66261946","209":"efd1ece8","248":"b5ce7e22","495":"f6c6ccea","700":"71537428","734":"8b03ace2","779":"6ad94a7f","872":"74bc8157","883":"77ef938f"}[chunkId] + ".chunk.js";
};